import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-artunteruntergrp-list-view',
  imports: [],
  templateUrl: './artunteruntergrp.list-view.html',
  styleUrls: ['./artunteruntergrp.list-view.css'],
})
export class ArtunteruntergrpListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
